import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IPersonnelTraining } from './interfaces';

export const getPersonnelTrainingList = (data: IDynamicTableParams) => {
  return instance()
    .post<IPersonnelTraining[]>('/personnelTraining/list', data)
    .then((response) => response.data);
};

export const getPersonnelTrainingAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/personnelTraining/availableColumns')
    .then((response) => response.data);
};

export const getPersonnelTrainingAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/personnelTraining/availableGroupColumns')
    .then((response) => response.data);
};

export const loadPersonnelTraining = (personnelTrainingId: number) => {
  return instance()
    .get<IPersonnelTraining>('/personnelTraining/load/' + personnelTrainingId)
    .then((response) => response.data);
};

export const createPersonnelTraining = (personnelTraining: IPersonnelTraining) => {
  return instance()
    .post<IPersonnelTraining>('/personnelTraining/save', personnelTraining)
    .then((response) => response.data);
};

export const updatePersonnelTraining = (personnelTraining: IPersonnelTraining) => {
  return instance()
    .post<IPersonnelTraining>(`/personnelTraining/${personnelTraining.personnelTrainingId}/update`, personnelTraining)
    .then((response) => response.data);
};

export const deletePersonnelTraining = (personnelTrainingId: number) => {
  return instance()
    .post('/personnelTraining/archive', { personnelTrainingId })
    .then((response) => response.data);
};

export const recoverPersonnelTraining = (personnelTrainingId: number) => {
  return instance()
    .post('/personnelTraining/recover', { personnelTrainingId })
    .then((response) => response.data);
};
